import React, { useEffect, useState } from 'react'
import StatusController from '../../components/statusController'
import MetaTags from 'react-meta-tags'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label
} from 'reactstrap'

import { PlusCircle } from 'react-feather'
import { Loading } from '../../components/Loading'

import { useUserInfo } from 'context/userContext'

import ReactDatePicker, { registerLocale } from 'react-datepicker'
import { Button, Form } from 'react-bootstrap'
import { listType } from '../../util/mocks'
import Select from 'react-select'

import ptBR from 'date-fns/locale/pt-BR'
import { ModalQrcode } from 'components/modalQrcode'
import { ModalQrcodeZApi } from 'components/modalQrcodeZApi'
import { TextArea } from '../../components/TextArea'
import { InputComponent } from 'components/inputComponent'
import { useFileUpload } from 'hooks/useFileUpload'
import { FileUpload } from 'components/fileUpload'
//@ts-ignore
import styles from './styles.module.scss'
import { useDisparador } from 'hooks/useDisparador'
import { Controller, useForm, type DefaultValues } from 'react-hook-form'
import {
  envioSimplificado,
  type EnvioSimplificadoSchema
} from './envioSimplificado.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import Table from 'components/Table'
import { ModalAddContacts } from 'components/modalAddContacts'
import { phoneMaskForList } from 'util/function'
import { toast } from 'react-toastify'

import { CampaignStepper } from '../EnviarPlanilha/components/CampaignStepper'
import { SectionCard } from '../EnviarPlanilha/components/SectionCard'
import { ContactsEmptyState } from '../EnviarPlanilha/components/ContactsEmptyState'
import { FormLabelWithTooltip } from '../EnviarPlanilha/components/FormLabelWithTooltip'
import {
  ReviewPanel,
  formatScheduleLabel
} from '../EnviarPlanilha/components/ReviewPanel'
import '../EnviarPlanilha/styles.css'
import { STATUS_OPTIONS } from 'types/envio'

registerLocale('pt-BR', ptBR)

const STEPS = ['Campanha', 'Contatos', 'Mensagem', 'Revisar']
const DRAFT_STORAGE_KEY = 'zap-plus-envio-simplificado-draft-v1'

const customStyles = {
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  })
}

const TableHeader = ({ onClick }) => {
  return (
    <Row>
      <Col xs={6}>Seus contatos</Col>
      <Col xs={6} className="text-end">
        <Button variant="success" onClick={() => onClick(true)}>
          Adicionar contatos <PlusCircle />
        </Button>
      </Col>
    </Row>
  )
}

const columns = [
  { label: 'Nome', field: 'name' },
  { label: 'Telefone', field: 'phone' }
]

const listMomento = [
  { label: 'Enviar Agora', value: 'now' },
  { label: 'Agendar Envio', value: 'after' }
]

function attachmentOk(v: Pick<EnvioSimplificadoSchema, 'type' | 'file' | 'link'>) {
  const t = v.type
  if (['imagem', 'video-arquivo', 'audio-arquivo', 'arquivo'].includes(t)) {
    return !!v.file
  }
  if (t === 'link') {
    return !!v.link?.trim()
  }
  return true
}

const defaultFormValues: DefaultValues<EnvioSimplificadoSchema> = {
  moment: 'now',
  type: 'texto',
  message: '',
  table: []
}

const EnvioSimplificao = () => {
  const { userPlan } = useUserInfo()

  const { onDrop } = useFileUpload()

  const pageForm = useForm<EnvioSimplificadoSchema>({
    resolver: zodResolver(envioSimplificado),
    defaultValues: defaultFormValues
  })
  const { control, watch, handleSubmit, setValue, getValues } = pageForm
  const watchInstanceId = watch('instanceId')
  const watchMoment = watch('moment')
  const watchType = watch('type')
  const watchFile = watch('file')
  const watchMessage = watch('message')
  const watchSchedule = watch('scheduleTime')

  const {
    loading,
    openModalQrcode,
    statusInstancia,
    zapMais,
    instanceName,
    instanceStateChecked,
    zapiData,
    listInstances,
    rendered,
    table,
    onCloseModalQrcode,
    onCloseOnSuccessModalQrcode,
    handleFileSelected,
    handleAddVariable,
    onError,
    onSubmit,
    setTable
  } = useDisparador(pageForm)

  const [rows, setRows] = useState([])
  const [showModalAdd, setShowModalAdd] = useState(false)
  const [activeStep, setActiveStep] = useState(0)

  const [tableConfig, setTableConfig] = useState({
    options: {
      collapse: false,
      more: true,
      uploadContacts: true,
      delete: true
    },
    config: {
      deleteText: 'Remover contato'
    },
    filters: {
      searchTerm: null,
      statusTransaction: 'paid',
      paidSale: false,
      startSaleDate: null,
      endSaleDate: null,
      eventId: null,
      sellerId: null
    },
    total: 0,
    currentPage: 0,
    rowsPerPage: 15
  })

  const loadDadosTable = async () => {
    const init = tableConfig.currentPage * tableConfig.rowsPerPage
    const finish = init + tableConfig.rowsPerPage

    const filterDados = table.slice(init, finish)
    setRows(filterDados)
  }

  const handleAddContacts = (data) => {
    const maxId = table.reduce(
      (m, r) => Math.max(m, typeof r.id === 'number' ? r.id : 0),
      0
    )
    const newTable = [
      ...table,
      ...data.map((item, index) => ({
        ...item,
        id: maxId + index + 1,
        phone: phoneMaskForList(item.phone)
      }))
    ]
    setTable(newTable)
    setValue('table', newTable)
    setShowModalAdd(false)
  }

  const handleRemoveContact = (row) => {
    const newTable = table.filter((item) => item.id !== row.id)
    setTable(newTable)
    setValue('table', newTable)
  }

  useEffect(() => {
    if (!rendered) return
    loadDadosTable()
  }, [tableConfig.currentPage, rendered, table])

  useEffect(() => {
    setValue('table', table)
    setTableConfig((prev) => ({ ...prev, total: table.length }))
  }, [table, setValue])

  useEffect(() => {
    try {
      const raw = localStorage.getItem(DRAFT_STORAGE_KEY)
      if (!raw) return
      const d = JSON.parse(raw)
      if (typeof d.instanceId === 'number') setValue('instanceId', d.instanceId)
      if (typeof d.message === 'string') setValue('message', d.message)
      if (d.moment) setValue('moment', d.moment)
      if (d.type) setValue('type', d.type)
      if (d.scheduleTime) setValue('scheduleTime', new Date(d.scheduleTime))
      if (typeof d.link === 'string') setValue('link', d.link)
      if (Array.isArray(d.table)) {
        setTable(d.table)
        setValue('table', d.table)
      }
    } catch {
      /* ignore */
    }
  }, [setValue, setTable])

  const stepComplete = (stepIndex) => {
    const v = getValues()
    if (stepIndex === 0) {
      const schedOk =
        userPlan === 'BASIC' ||
        v.moment !== 'after' ||
        (v.scheduleTime !== null &&
          v.scheduleTime !== undefined &&
          !Number.isNaN(v.scheduleTime.getTime()))
      const needInstance = listInstances.length > 0
      const instanceOk =
        !needInstance ||
        (typeof v.instanceId === 'number' &&
          !Number.isNaN(v.instanceId) &&
          v.instanceId > 0)
      return Boolean(instanceOk && v.type && schedOk && attachmentOk(v))
    }
    if (stepIndex === 1) {
      return table.length > 0
    }
    if (stepIndex === 2) {
      return String(v.message || '').trim().length > 0
    }
    return true
  }

  const canNavigateToStep = (targetIndex) => {
    for (let s = 0; s < targetIndex; s++) {
      if (!stepComplete(s)) return false
    }
    return true
  }

  const canReview =
    stepComplete(0) && stepComplete(1) && stepComplete(2)

  const saveDraft = () => {
    try {
      const v = getValues()
      const payload = {
        instanceId: v.instanceId,
        message: v.message,
        moment: v.moment,
        type: v.type,
        scheduleTime: v.scheduleTime?.toISOString?.() ?? null,
        link: v.link ?? '',
        table
      }
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(payload))
      toast.success('Rascunho salvo')
    } catch {
      toast.error('Não foi possível salvar o rascunho')
    }
  }

  const instanceLabel =
    listInstances.find((a) => a.value === watchInstanceId)?.label ??
    'Envio simplificado'

  const hasAttachmentFields =
    watchType === 'imagem' ||
    watchType === 'video-arquivo' ||
    watchType === 'audio-arquivo' ||
    watchType === 'arquivo' ||
    watchType === 'link'

  return (
    <React.Fragment>
      {loading && <Loading open={loading} />}
      <div className="page-content">
        <MetaTags>
          <title>Envio simplificado | Zap+</title>
        </MetaTags>
        <Container fluid>
          <Form id="form-envio-simplificado">
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col md={8}>
                  <h6 className="page-title mb-1">Envio simplificado | Zap+</h6>
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item active">
                      Bem vindo ao Envio simplificado Zap+
                    </li>
                  </ol>
                </Col>
                <Col
                  md={4}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                  }}
                >
                  {watchInstanceId && (
                    <>
                      <span
                        style={{
                          marginRight: 10,
                          fontWeight: 500,
                          fontSize: 20
                        }}
                      >
                        {statusInstancia === STATUS_OPTIONS.CONNECTED
                          ? 'Conectado'
                          : statusInstancia === STATUS_OPTIONS.PAST_DUE
                          ? 'Bloqueado'
                          : 'Desconectado'}
                      </span>
                      <StatusController statusInstancia={statusInstancia} />
                    </>
                  )}
                </Col>
              </Row>
            </div>
            <Row>
              <Card
                className="enviar-planilha-card border shadow-sm"
                style={{ padding: 0 }}
              >
                <CardBody className="p-3 p-md-4">
                  <CampaignStepper
                    steps={STEPS}
                    activeIndex={activeStep}
                    onStepClick={setActiveStep}
                    canNavigateToStep={canNavigateToStep}
                  />

                  <div className="enviar-planilha-cards-stack">
                    <div className={activeStep === 0 ? '' : 'd-none'}>
                      <SectionCard
                        title="Configure o envio"
                        subtitle="Instância WhatsApp, tipo de mensagem, agendamento e anexos quando aplicável."
                      >
                        <Row className="g-3">
                          <Col md={6}>
                            <Controller
                              control={control}
                              name="instanceId"
                              render={({ field }) => (
                                <FormGroup>
                                  <FormLabelWithTooltip
                                    htmlFor="instance-envio-simpl"
                                    required={listInstances.length > 0}
                                    tooltip="Selecione qual WhatsApp conectado será usado para enviar."
                                  >
                                    Quem está enviando a mensagem?
                                  </FormLabelWithTooltip>
                                  <Select
                                    inputId="instance-envio-simpl"
                                    value={
                                      listInstances.find(
                                        (a) => a.value === field.value
                                      )
                                        ? listInstances.find(
                                            (a) => a.value === field.value
                                          )
                                        : null
                                    }
                                    onChange={(value) =>
                                      field.onChange(value?.value)
                                    }
                                    options={listInstances}
                                    classNamePrefix="select2-selection"
                                    placeholder="Selecione..."
                                    styles={customStyles}
                                  />
                                </FormGroup>
                              )}
                            />
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Controller
                                control={control}
                                name="type"
                                render={({ field }) => (
                                  <>
                                    <FormLabelWithTooltip
                                      htmlFor="tipo-msg-simples"
                                      required
                                      tooltip="Escolha o formato da mensagem (texto, imagem, arquivo, etc.)."
                                    >
                                      Tipo de mensagem
                                    </FormLabelWithTooltip>
                                    <Select
                                      inputId="tipo-msg-simples"
                                      value={
                                        listType.find(
                                          (a) => a.value === field.value
                                        )
                                          ? listType.find(
                                              (a) => a.value === field.value
                                            )
                                          : null
                                      }
                                      onChange={(value) =>
                                        field.onChange(value?.value)
                                      }
                                      options={listType}
                                      classNamePrefix="select2-selection"
                                      placeholder="Selecione..."
                                      styles={customStyles}
                                    />
                                  </>
                                )}
                              />
                            </FormGroup>
                          </Col>
                          {userPlan !== 'BASIC' && (
                            <Col md={6}>
                              <FormGroup>
                                <Controller
                                  control={control}
                                  name="moment"
                                  render={({ field }) => (
                                    <>
                                      <FormLabelWithTooltip
                                        htmlFor="momento-simples"
                                        required
                                        tooltip="Envio imediato ou agendado para data e hora específicas."
                                      >
                                        Agendamento
                                      </FormLabelWithTooltip>
                                      <Select
                                        inputId="momento-simples"
                                        value={
                                          listMomento.find(
                                            (a) => a.value === field.value
                                          )
                                            ? listMomento.find(
                                                (a) => a.value === field.value
                                              )
                                            : null
                                        }
                                        onChange={(value) =>
                                          field.onChange(value?.value)
                                        }
                                        options={listMomento}
                                        classNamePrefix="select2-selection"
                                        placeholder="Selecione..."
                                        styles={customStyles}
                                      />
                                    </>
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          )}
                          {watchMoment === 'after' && userPlan !== 'BASIC' && (
                            <Col md={6}>
                              <Form.Group>
                                <FormLabelWithTooltip
                                  htmlFor="hora-envio-simples"
                                  required
                                  tooltip="Data e hora em que o envio deve iniciar."
                                >
                                  Data e hora do envio
                                </FormLabelWithTooltip>
                                <Controller
                                  control={control}
                                  name="scheduleTime"
                                  render={({ field }) => (
                                    <ReactDatePicker
                                      id="hora-envio-simples"
                                      className="form-control"
                                      selected={field.value}
                                      onChange={(date) => field.onChange(date)}
                                      timeIntervals={15}
                                      showTimeSelect
                                      dateFormat="dd/MM/yyyy HH:mm:ss"
                                      locale="pt-BR"
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          )}
                        </Row>

                        {hasAttachmentFields && (
                          <>
                            <div className="enviar-planilha-subtle-label mt-4 mb-2">
                              Anexos
                            </div>
                            <Row className="g-3">
                              {watchType === 'imagem' && (
                                <Col xl={5} md={6}>
                                  <FormGroup>
                                    <Label for="img-simples">Imagem</Label>
                                    <div className={styles.fileUploader}>
                                      <FileUpload
                                        text="Clique aqui para selecionar ou arraste a <strong>IMAGEM</strong>"
                                        onDrop={(
                                          acceptedFiles,
                                          fileRejections
                                        ) =>
                                          onDrop(
                                            acceptedFiles,
                                            fileRejections,
                                            10000000,
                                            () =>
                                              handleFileSelected(acceptedFiles)
                                          )
                                        }
                                        maxSize={10000000}
                                        accept={['.png', '.JPEG', '.jpeg', '.jpg']}
                                        suggestion={
                                          watchFile?.name
                                            ? `Imagem selecionada: <strong>${watchFile.name}</strong>`
                                            : null
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                              {watchType === 'arquivo' && (
                                <>
                                  <Col xl={5} md={6}>
                                    <FormGroup>
                                      <Label>Arquivo</Label>
                                      <div className={styles.fileUploader}>
                                        <FileUpload
                                          text="Clique aqui para selecionar ou arraste o <strong>ARQUIVO PDF</strong>"
                                          onDrop={(
                                            acceptedFiles,
                                            fileRejections
                                          ) =>
                                            onDrop(
                                              acceptedFiles,
                                              fileRejections,
                                              50000000,
                                              () =>
                                                handleFileSelected(
                                                  acceptedFiles
                                                )
                                            )
                                          }
                                          maxSize={50000000}
                                          accept={['.pdf']}
                                          suggestion={
                                            watchFile?.name
                                              ? `Arquivo de no máximo 50M<br/>Arquivo selecionado: <strong>${watchFile.name}</strong>`
                                              : 'Arquivo de no máximo 50M'
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </Col>
                                  <Col xl={4} md={4}>
                                    <Controller
                                      control={control}
                                      name="fileName"
                                      render={({ field }) => (
                                        <InputComponent
                                          {...field}
                                          label="Nome do Arquivo"
                                        />
                                      )}
                                    />
                                  </Col>
                                </>
                              )}
                              {watchType === 'video-arquivo' && (
                                <Col xl={5} md={5}>
                                  <FormGroup>
                                    <Label for="vid-simples">Vídeo</Label>
                                    <div className={styles.fileUploader}>
                                      <FileUpload
                                        text="Clique aqui para selecionar ou arraste o <strong>VÍDEO</strong>"
                                        onDrop={(
                                          acceptedFiles,
                                          fileRejections
                                        ) =>
                                          onDrop(
                                            acceptedFiles,
                                            fileRejections,
                                            15000000,
                                            () =>
                                              handleFileSelected(acceptedFiles)
                                          )
                                        }
                                        maxSize={15000000}
                                        accept={['.3gp', '.mp4']}
                                        suggestion={
                                          watchFile?.name
                                            ? `Arquivo de no máximo 15M<br/>Arquivo selecionado: <strong>${watchFile.name}</strong>`
                                            : 'Arquivo de no máximo 15M'
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                              {watchType === 'audio-arquivo' && (
                                <Col xl={4} md={4}>
                                  <FormGroup>
                                    <Label for="aud-simples">Arquivo</Label>
                                    <div className={styles.fileUploader}>
                                      <Input
                                        type="file"
                                        onChange={(e) =>
                                          handleFileSelected(e.target.files)
                                        }
                                        accept=".ogg, .mp3"
                                      />
                                    </div>
                                  </FormGroup>
                                </Col>
                              )}
                              {watchType === 'link' && (
                                <Col xl={4} md={4}>
                                  <Controller
                                    control={control}
                                    name="link"
                                    render={({ field }) => (
                                      <InputComponent {...field} label="Link" />
                                    )}
                                  />
                                </Col>
                              )}
                            </Row>
                          </>
                        )}
                      </SectionCard>
                    </div>

                    <div className={activeStep === 1 ? '' : 'd-none'}>
                      <SectionCard
                        title="Contatos"
                        subtitle="Adicione manualmente os destinatários do disparo."
                      >
                        <Table
                          title={<TableHeader onClick={setShowModalAdd} />}
                          columns={columns}
                          rows={rows}
                          tableConfig={tableConfig}
                          setTableConfig={setTableConfig}
                          emptyText="Nenhum contato adicionado"
                          onDelete={handleRemoveContact}
                        />
                        {table.length === 0 ? (
                          <div className="mt-3">
                            <ContactsEmptyState />
                          </div>
                        ) : null}
                      </SectionCard>
                    </div>

                    <div className={activeStep === 2 ? '' : 'd-none'}>
                      <SectionCard
                        title="Mensagem"
                        subtitle="Escreva o texto e use as variáveis para personalizar por contato."
                      >
                        <FormGroup>
                          <FormLabelWithTooltip
                            htmlFor="message-text-area"
                            required
                            tooltip="Corpo da mensagem enviada no WhatsApp."
                          >
                            Texto da mensagem
                          </FormLabelWithTooltip>
                          <Controller
                            control={control}
                            name="message"
                            render={({ field }) => (
                              <TextArea
                                title={false}
                                hideLabel
                                value={field.value}
                                setValue={(value) => field.onChange(value)}
                                onAddVariable={handleAddVariable}
                                messagevariables={[]}
                                variableLayout="chips"
                                placeholder="Olá {nome}, temos uma novidade para você!"
                                maxLength={4096}
                                showCharCounter
                              />
                            )}
                          />
                        </FormGroup>
                      </SectionCard>
                    </div>

                    <div className={activeStep === 3 ? '' : 'd-none'}>
                      <SectionCard
                        title="Revisar"
                        subtitle="Confira os dados antes de confirmar o envio."
                      >
                        <ReviewPanel
                          campaignName={instanceLabel}
                          contactCount={table.length}
                          message={watchMessage || ''}
                          scheduleLabel={formatScheduleLabel(
                            watchMoment,
                            watchSchedule
                          )}
                          sampleContacts={table}
                          extraVariables={[]}
                        />
                        <div className="d-flex flex-wrap justify-content-between gap-2 mt-4 enviar-planilha-review-actions">
                          <Button
                            type="button"
                            variant="outline-secondary"
                            onClick={() => setActiveStep(2)}
                          >
                            Voltar
                          </Button>
                          {statusInstancia === STATUS_OPTIONS.CONNECTED ? (
                            <Button
                              type="button"
                              className="enviar-planilha-btn-primary"
                              disabled={loading || !canReview}
                              onClick={() =>
                                handleSubmit(onSubmit, onError)()
                              }
                            >
                              {loading ? 'Enviando…' : 'Confirmar envio'}
                            </Button>
                          ) : (
                            <span className="text-muted small align-self-center">
                              Conecte o WhatsApp na etapa Campanha para enviar.
                            </span>
                          )}
                        </div>
                      </SectionCard>
                    </div>
                  </div>

                  {activeStep < 3 && (
                    <Row className="mt-4 pt-3 enviar-planilha-actions">
                      <Col
                        xs={12}
                        className="d-flex flex-wrap justify-content-between align-items-center gap-2 enviar-planilha-step-footer"
                      >
                        <div>
                          {activeStep > 0 ? (
                            <Button
                              type="button"
                              variant="outline-secondary"
                              onClick={() =>
                                setActiveStep((s) => Math.max(0, s - 1))
                              }
                            >
                              Voltar
                            </Button>
                          ) : null}
                        </div>
                        <div className="d-flex flex-wrap enviar-planilha-footer-actions ms-auto">
                          <Button
                            type="button"
                            variant="outline-secondary"
                            onClick={saveDraft}
                          >
                            Salvar rascunho
                          </Button>
                          {activeStep < 2 ? (
                            <Button
                              type="button"
                              className="enviar-planilha-btn-primary"
                              disabled={!stepComplete(activeStep)}
                              onClick={() =>
                                setActiveStep((s) => Math.min(2, s + 1))
                              }
                            >
                              Próximo passo
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              className="enviar-planilha-btn-primary"
                              disabled={!canReview}
                              onClick={() => setActiveStep(3)}
                            >
                              Revisar e enviar
                            </Button>
                          )}
                        </div>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Row>
          </Form>
        </Container>
      </div>
      {zapMais && (
        <ModalQrcode
          showModal={openModalQrcode}
          onClose={onCloseModalQrcode}
          instanceId={watchInstanceId}
          statusInstance={statusInstancia}
          instanceName={instanceName}
          onSuccess={onCloseOnSuccessModalQrcode}
          instanceChecked={instanceStateChecked}
        />
      )}
      {!zapMais && (
        <ModalQrcodeZApi
          showModal={openModalQrcode}
          onClose={onCloseModalQrcode}
          instanceId={watchInstanceId}
          statusInstance={statusInstancia}
          instanceName={instanceName}
          onSuccess={onCloseOnSuccessModalQrcode}
          instanceChecked={instanceStateChecked}
          zapiData={zapiData}
        />
      )}
      {showModalAdd && (
        <ModalAddContacts
          onClose={() => setShowModalAdd(false)}
          onConfirm={handleAddContacts}
          showModal={showModalAdd}
        />
      )}
    </React.Fragment>
  )
}

export default EnvioSimplificao
